import { atom } from 'recoil';

const couponNumberState = atom({
  key: 'couponNumberState',
  default: '',
});

const couponProductIdState = atom({
  key: 'couponProductIdState',
  default: '',
});

export { couponNumberState, couponProductIdState };
